import { AlertTriangle } from 'lucide-react';

function ApiDownBanner() {
  return (
    <div className="bg-yellow-50 dark:bg-yellow-900/20 border-b border-yellow-200 dark:border-yellow-800">
      <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-yellow-100 dark:bg-yellow-800">
              <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
            </span>
            <p className="ml-3 font-medium text-yellow-800 dark:text-yellow-200">
              <span className="md:hidden">API connection issue detected.</span>
              <span className="hidden md:inline">
                API connection issue detected. Some features may be unavailable.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApiDownBanner;
